import React, { useState } from 'react';

import { Workshop_Url } from '../../ApiConfig';

import style from '../../../css/admin/Workshopupload.module.css';
import ViewWorkshops from './Workshop_table_data';

const StudymaterialUpload = () => {


  return (
    <>
      <div className={style.uploadContainer}>

        <button
          className={style.uploadButton}
          onClick={() => window.open('/upload-workshop-form')}
        >
          <i className="fa-solid fa-cloud-arrow-up"></i> Workshop
        </button>
      </div>

      <ViewWorkshops />
    </>
  );
};

export default StudymaterialUpload;
